<template>

<!-- EDIT HERE -->

<div class="container">
<section class="section rules text-center" id="rules">
<div class="tabs">
  <div class="spoon is-medium is-primary">Rules</div>
</div>
<!-- THIS TEXT IS COPYPASTED FROM MOOSE.GG, perhaps you need to change it! >>> -->
<h3>VAC/Game Bans</h3>
<ul class="text-start">
<li>1 VAC or Game Ban allowed across all accounts.</li>
<li>Any VAC or Game Ban must be over 1 year old (365 days).</li>
<li>If you have multiple bans of different types, you will be banned. 1 VAC and 1 Game Ban is NOT allowed.</li>
<li>There are absolutely NO exceptions to this rule. The answer will always be no so do not ask.</li>
</ul>
<h3>Racism & Bigotry</h3>
<ul class="text-start">
<li>We have absolutely zero tolerance for any form of racism or bigotry. You can do whatever you like in your day to day lives, but it will not be tolerated on our servers.</li>
<li>Don't type it, don't write/draw on a sign, and don't say it in voice chat. Admins spectate constantly and if we see it, you will be banned.</li>
<li>Very rarely do we warn. By playing on our servers you are consenting to our rules and understand the consequences for not following them.</li>
</ul>
<h3>Disrespecting Staff & Players</h3>
<ul class="text-start">
<li>This is an online game and there will ALWAYS be trash talk going on. We get it. However, that doesn't mean you get to leave all of your morals at the door. Use common sense and do not go after other players or admins with personal attacks. You will be removed.</li>
<li>If your friend broke the rules and was punished for it, don't try to argue with an admin about our decision. Go find a new server and accept the consequences for your actions.</li>
<li>Be a decent human being. I know this is Rust, but there is no need to be an all around shitty person.</li>
</ul>
<!-- <<< THIS TEXT IS COPYPASTED FROM MOOSE.GG, perhaps you need to change it! -->
</section>
</div>

<!-- EDIT HERE -->

</template>


<script>
export default {
  name: 'rulesSection'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.store {
	padding-top: 10rem;
}
#rules > h3 {
	color: var(--color-highlight);
}
ul.text-start > li {
	color: var(--color-mute);
}
</style>